import { appConfig } from "core/configs/app.config";
import { ChangeEvent } from "react";
import AppSelect from "../app-select";
import "./style.scss";

const MAX_PAGE_VIEW = 5;
const MAX_PAGE_VIEW_TRUNC = Math.trunc(MAX_PAGE_VIEW / 2);

interface Props {
	currentPage: number;
	pageSize: number;
	totalElements?: number;
	onPageChange?: (page: number) => void;
	onPageSizeChange: (pageSize: number) => void;
}

const AppPaginator: React.FC<Props> = (props) => {
	const {
		currentPage,
		totalElements,
		pageSize,
		onPageChange,
		onPageSizeChange,
	} = props;

	var totalPages = Math.ceil((totalElements ?? 0) / pageSize) || 1;

	const handlePageSizeChange = (event: ChangeEvent<HTMLSelectElement>) => {
		onPageSizeChange?.(Number(event?.target?.value));
	};

	const handlePrevClick = () => {
		onPageChange?.(currentPage - 1);
	};

	const handleSelectPage = (page: number) => {
		onPageChange?.(page);
	};

	const handleNextClick = () => {
		onPageChange?.(currentPage + 1);
	};

	const _getMinPage = () => {
		if (totalPages) {
			if (
				currentPage >= MAX_PAGE_VIEW_TRUNC &&
				currentPage < totalPages - MAX_PAGE_VIEW_TRUNC
			) {
				return currentPage - MAX_PAGE_VIEW_TRUNC;
			}

			if (currentPage > totalPages - MAX_PAGE_VIEW)
				return totalPages - MAX_PAGE_VIEW + 1;
		}

		return 0;
	};

	const _getMaxPage = () => {
		if (totalPages) {
			if (
				currentPage > MAX_PAGE_VIEW_TRUNC &&
				currentPage <= totalPages - MAX_PAGE_VIEW_TRUNC
			) {
				return currentPage + MAX_PAGE_VIEW_TRUNC;
			}

			if (currentPage < MAX_PAGE_VIEW) return MAX_PAGE_VIEW;
		}

		return totalPages || 0;
	};

	return (
		<div className="grid grid-cols-1 md:grid-cols-2 app-paginator">
			<div className="app-paginator_page-size hidden md:block">
				<AppSelect onChange={handlePageSizeChange} size="sm">
					{appConfig.tablePageSizes?.map((p) => (
						<option value={p} key={`app-paginator_page-size-item-${p}`}>
							{p}
						</option>
					))}
				</AppSelect>
			</div>

			<div className="app-paginator_page">
				<div className="me-2 hidden md:block">{totalElements} Totali</div>

				<div className="app-paginator_page-selector">
					<div className="join paginator">
						<button
							className="join-item btn btn-sm"
							onClick={() => handlePrevClick()}
							disabled={currentPage === 1}
						>
							{"<"}
						</button>

						{Array.from(Array(totalPages).keys()).map((_, i) => {
							let pageNumber: number = i + 1;
							let minPage: number = _getMinPage();
							let maxPage: number = _getMaxPage();

							if (pageNumber > minPage && pageNumber <= maxPage)
								return (
									<button
										className={`join-item btn btn-sm ${
											pageNumber === currentPage ? "active" : ""
										}`}
										key={`pagination-item-${pageNumber}`}
										onClick={() => handleSelectPage(pageNumber)}
									>
										{pageNumber}
									</button>
								);
						})}

						<button
							className="join-item btn btn-sm"
							onClick={() => handleNextClick()}
							disabled={currentPage === totalPages || totalPages === 1}
						>
							{">"}
						</button>
					</div>

					<AppSelect
						className="hidden md:block page-selector"
						value={currentPage}
						onChange={(e) => handleSelectPage(Number(e.currentTarget.value))}
						size="sm"
					>
						{Array.from(Array(totalPages).keys()).map((_, i) => {
							let pageNumber: number = i + 1;

							return (
								<option
									key={`page-selector-item-${pageNumber}`}
									value={pageNumber}
								>
									Pag {pageNumber} di {totalPages}
								</option>
							);
						})}
					</AppSelect>
				</div>
			</div>
		</div>
	);
};
export default AppPaginator;
